<template>
  <div
    v-if="!searchOpen"
    class="ca-header__button-wrapper gap-size-3"
    :class="{ 'is-simplified': isSimplifiedMenu }"
  >
    <!-- Menu normal -->
    <template v-if="!isSimplifiedMenu">
      <CaHeaderButton
        v-for="(item, colIdx) in items"
        :key="colIdx"
        :is-hovered="hoveredIndex === colIdx"
        :disabled="isLoading"
        @click="emit('navigate', colIdx)"
        @mouseenter="emit('open-menu', colIdx)"
        @mouseleave="emit('close-menu')"
        @keydown-enter="emit('handle-enter', colIdx)"
      >
        <CaHeaderMegamenuHeaderTitle>
          {{ !isLoading ? item.title : "" }}
        </CaHeaderMegamenuHeaderTitle>
      </CaHeaderButton>
    </template>

    <!-- Menu simplificado -->
    <template v-else>
      <template v-if="parentItem">
        <span class="ca-header-nav-parent-title mr-size-4 caption-medium">
          <span class="ca-header-nav-parent-title__full">{{
            parentItem.title
          }}</span>
          <span class="ca-header-nav-parent-title__initials">{{
            getInitials(parentItem.title)
          }}</span>
        </span>
        <div class="ca-header__nav-divider" aria-hidden="true" />
      </template>
      <!-- Categories -->
      <CaHeaderButton
        v-for="(item, colIdx) in simplifiedItems"
        :key="colIdx"
        :is-active="currentPath.startsWith(item.url)"
        :disabled="isLoading"
        @click="emit('navigate-category', item)"
        @keydown-enter="emit('handle-enter', colIdx)"
      >
        <CaHeaderMegamenuHeaderTitle>
          {{ item.title }}
        </CaHeaderMegamenuHeaderTitle>
      </CaHeaderButton>
    </template>
  </div>
</template>

<script setup>
import CaHeaderButton from "./CaHeaderButton.vue";
import CaHeaderMegamenuHeaderTitle from "./CaHeaderMegamenuHeaderTitle.vue";

defineProps({
  items: { type: Array, default: () => [] },
  simplifiedItems: { type: Array, default: () => [] },
  parentItem: { type: Object, default: null },
  hoveredIndex: { type: Number, default: null },
  isLoading: { type: Boolean, default: false },
  isSimplifiedMenu: { type: Boolean, default: false },
  searchOpen: { type: Boolean, default: false },
  currentPath: { type: String, default: "" },
});

const emit = defineEmits([
  "navigate",
  "open-menu",
  "close-menu",
  "handle-enter",
  "navigate-category",
]);

const getInitials = (title) => {
  if (!title) return "";
  return title
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};
</script>

<style scoped lang="scss">
.ca-header__button-wrapper {
  display: flex;

  &:not(.is-simplified) {
    @media (max-width: 1163px) {
      display: none;
    }
  }

  @media (max-width: 1164px) {
    display: none;
  }
}

.is-simplified {
  @media (max-width: 1024px) {
    display: none;
  }
}

.ca-header__nav-divider {
  width: 1px;
  align-self: stretch;
  background-color: var(--ca-color-text-light);
  flex-shrink: 0;
}

@media (min-width: 1024px) and (max-width: 1137px) {
  .ca-header__button-wrapper:not(.is-simplified) {
    gap: var(--size-2);
  }
}

.ca-header-nav-parent-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--ca-color-theme-primary);
}

.ca-header-nav-parent-title__initials {
  display: none;
}

@media (min-width: 1025px) and (max-width: 1168px) {
  .ca-header-nav-parent-title__full {
    display: none;
  }
  .ca-header-nav-parent-title__initials {
    display: inline;
  }
}

@media (min-width: 1025px) and (max-width: 1067px) {
  .ca-header__button-wrapper {
    gap: var(--size-1);
  }
}

@media (min-width: 1169px) and (max-width: 1184px) {
  .ca-header__button-wrapper {
    gap: var(--size-2);
  }
}
</style>
